var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{key:_vm.key,staticClass:"mindmap-container"},[_c('Toolbar'),_c('Edit',{attrs:{"org-data":_vm.caseTreeData}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }